import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import group from '../../assets/images/Group 1321314599 (1).webp'
import bggroup from '../../assets/images/Group 1321314600.webp'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import bgforwarding from '../../assets/images/Group 1321314601.webp'
import bginspection from '../../assets/images/Group 1321314665.webp'
import bgtrading from '../../assets/images/Group 1321314666.webp'
import bgcard1 from '../../assets/images/Group 13.webp'
import bgcard2 from '../../assets/images/Group 14.webp'
import bgcard3 from '../../assets/images/Group 13 (1).webp'
import bgcard4 from '../../assets/images/Group 13 (2).webp'
import hover from '../../assets/images/image 22.webp'
import missiongroup from '../../assets/images/Group.webp'
import avatar from '../../assets/images/Team Avatar.webp'
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import upcard from '../../assets/images/Group (1).webp'
import mission1 from '../../assets/images/Group 1321314670.webp'
import mission2 from '../../assets/images/Group 1321314671.webp'
import axios from 'axios'
import forwardimg1 from '../../assets/images/g1558.webp'
import forwardimg2 from '../../assets/images/globe_16642679 1.webp'
import forwardimg3 from '../../assets/images/contract_1358533 1.webp'
import forwardimg4 from '../../assets/images/evaluation_6757112 1.webp'
import forwardimg5 from '../../assets/images/order-tracking_4400107 1.webp'
import inspectionimg1 from '../../assets/images/taxi_18215380 1.webp'
import inspectionimg2 from '../../assets/images/clipboard_1150609 1.webp'
import inspectionimg3 from '../../assets/images/report_18841312 1.webp'
import inspectionimg4 from '../../assets/images/globe_17132037 1.webp'
import inspectionimg5 from '../../assets/images/box_1582517 1.webp'
import inspectionimg6 from '../../assets/images/scale_1172705 1.webp'
import inspectionimg7 from '../../assets/images/note_5832191 1.webp'
import inspectionimg8 from '../../assets/images/ship_17524039 1.webp'
import inspectionimg9 from '../../assets/images/plan_1559992 1.webp'
import inspectionimg10 from '../../assets/images/loading-bar_12884220 1.webp'
import inspectionimg11 from '../../assets/images/deadline_18127678 1.webp'
import inspectionimg12 from '../../assets/images/emergency_17871238 1.webp'
import inspectionimg13 from '../../assets/images/ship_18814612 1.webp'
import tradingimg1 from '../../assets/images/chart_12668243 1.webp'
import tradingimg2 from '../../assets/images/order-processing_18546692 1.webp'
import tradingimg3 from '../../assets/images/insurance_1942624 1.webp'
import tradingimg4 from '../../assets/images/cooperation_18488942 1.webp'
import tradingimg5 from '../../assets/images/risk_2172550 1.webp'
import tradingimg6 from '../../assets/images/execution_11670479 1.webp'
import { forward, inspection, trading } from "../Ourservices/Forwarding";
import CustomModal from "../../common/CommonModel";
import logo from '../../assets/images/g8.webp'
const HomeContent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setloading] = useState(false);
  const cards = [
    { id: 0, title: "Customized Shipping Plans", image: forwardimg1, colorClass: "card-color1", content: "We craft and provide tailored logistics strategies that align with your business goals, optimizing routes, modes of transport, and handling procedures for cost-efficiency and speed." },
    { id: 1, title: " Global Network Access", image: forwardimg2, colorClass: "card-color1", content: "  Leverage our extensive network of carriers, ports, and partners worldwide to ensure your cargo moves seamlessly across international borders." },
    { id: 2, title: " Documentation & Customs Clearance", image: forwardimg3, colorClass: "card-color1", content: "We handle the paperwork, from Bills of Lading to customs declarations, ensuring compliance and reducing the risk of delays at customs." },
    { id: 3, title: " Risk Management", image: forwardimg4, colorClass: "card-color1", content: "  Stay informed with our advanced tracking systems that provide real-time updates on your shipment's progress, keeping you at peace." },
    { id: 4, title: " End-to-End Logistics", image: forwardimg5, colorClass: "card-color1", content: "  Stay informed with our advanced tracking systems that provide real-time updates on your shipment's progress, keeping you at peace." },
  ];
  const cards1 = [
    { id: 5, title: " ISM and ISPS Audits", image: inspectionimg1, colorClass: "card-color1" },
    { id: 6, title: " Navigation Audits", image: inspectionimg2, colorClass: "card-color1" },
    { id: 7, title: " Safety Equipment Audits", image: inspectionimg3, colorClass: "card-color1" },
    { id: 8, title: " General & Project Cargo Inspections", image: inspectionimg4, colorClass: "card-color1" },
    { id: 9, title: " Cargo Pre-Shipment/ Discharge Checks", image: inspectionimg5, colorClass: "card-color1" },
    { id: 10, title: " Cargo Measurement/ Weighment", image: inspectionimg6, colorClass: "card-color1" },
    { id: 11, title: " Tally & Condition Assessments", image: inspectionimg7, colorClass: "card-color1" },
    { id: 12, title: " Cargo Stowage & Lashing", image: inspectionimg8, colorClass: "card-color1" },
    { id: 13, title: " Vessel Draft Surveys", image: inspectionimg9, colorClass: "card-color1" },
    { id: 14, title: " Pre-Loading/Discharging Sampling & Analysis", image: inspectionimg10, colorClass: "card-color1" },
    { id: 15, title: " Cargo Loading/Discharging Supervision", image: inspectionimg11, colorClass: "card-color1" },
    { id: 16, title: "Onboard Crew Training ", image: inspectionimg12, colorClass: "card-color1" },
    { id: 17, title: "Inventory Inspections onboard Ships", image: inspectionimg13, colorClass: "card-color1" },
  ];
  const cards2 = [
    { id: 18, title: "Market Insight and Analysis", image: tradingimg1, colorClass: "card-color1" },
    { id: 19, title: "Sourcing and Procurement", image: tradingimg2, colorClass: "card-color1" },
    { id: 20, title: "Trade Compliance", image: tradingimg3, colorClass: "card-color1" },
    { id: 21, title: " Strategic Partnerships", image: tradingimg4, colorClass: "card-color1" },
    { id: 22, title: " Risk Assessment and Mitigation", image: tradingimg5, colorClass: "card-color1" },
    { id: 23, title: "Value-Added Services", image: tradingimg6, colorClass: "card-color1" },
  ];
  const [activeSection, setActiveSection] = useState("Forwarding");

  const toggleSection = (section) => {
    setActiveSection(section);
  };


  return (

    <div className="">
      <section className="overflow-hidden about-section" id="Services">
        <div className="container mt-5">
          <div className="service_banner" data-aos="fade-down" data-aos-duration="1000">
            <h1>
              Our Service<span>s</span>
            </h1>
          </div>
          <div className={`row padding-before border-b ${activeSection === "Forwarding" ? "padding-py" : ""}`}
            onMouseOver={() => toggleSection("Forwarding")}>
            <div className="col-lg-6">
              <div className="d-flex serviceicon gap-4">
                <div className="d-flex gap-4">
                  <p className="mobalign">Freight Forwarding</p>
                  <div className={`collapse mt-3 ${activeSection === "Forwarding" ? "show positionbgfor" : ""}`} id="tabs">
                    <img src={bgforwarding} className="bgimg" alt='service' />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 servicefont">
              <div className="d-flex gap-5 mobparapy">
                <p>Northwood specializes in end-to-end freight forwarding, offering a seamless...</p>
                <Link to={`/Service/forwarding`} className="text-decoration-none" >
                  <i className={`fa-solid fa-arrow-right service rounded-circle mobdisplay ${activeSection === "Forwarding" ? "rotate-arrow" : ""}`}></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-1 textalign">
              <Link to={`/Service/forwarding`} className="text-decoration-none">
                <i className={`fa-solid fa-arrow-right service rounded-circle webdisplay ${activeSection === "Forwarding" ? "rotate-arrow" : ""}`}></i>
              </Link>
            </div>
          </div>

          <div className={`collapse ${activeSection === "Forwarding" ? "show" : ""}`} id="tabs">
            <div className="container padding-service overflow-hidden">
              <div className="row padding-service">
                <OwlCarousel
                  className="owl-theme"
                  loop={true}
                  rewind={false}
                  margin={10}
                  nav={false}
                  dots={false}
                  // center={true}
                  autoplay={true}
                  autoplayTimeout={1000}
                  autoplayHoverPause={true}
                  responsive={{
                    0: { items: 1 },
                    600: { items: 2 },
                    1000: { items: 4 },
                  }}
                >

                  {cards.map((card, index) => (
                    <Link to={`/Service/forwarding`} className="text-decoration-none linkcolor">
                      <div
                        className={`card-item ${card.colorClass}`}
                      // onMouseEnter={() => setActiveIndex(index)}
                      // onMouseLeave={() => setActiveIndex(0)}
                      >
                        <img src={hover} className={`hoverimg hoverimg${index}`} alt="hover1" />
                        <div className="owlcard-container">
                          <img src={card.image} className="owlcard " alt={`card${index + 1}`} />
                        </div>
                        <h1>{card.title}</h1>
                        <Link to={`/Service/forwarding`} className="text-decoration-none linkcolor">
                          <i className="fa-solid fa-arrow-right cardarrow rounded-circle"></i>
                        </Link>
                      </div>
                    </Link>
                  ))}
                </OwlCarousel>

              </div>
            </div>
          </div>

          <div className={`row padding-before border-b ${activeSection === "inspection" ? "padding-py" : ""}`}
            onMouseOver={() => toggleSection("inspection")}>
            <div className="col-lg-6">
              <div className="d-flex serviceicon gap-4">
                <div className="d-flex gap-4" >

                  <p className="mobalign">Vessel Inspection</p>
                  <div className={`collapse mt-3 ${activeSection === "inspection" ? "show positionbg" : ""}`} id="tabs">
                    <img src={bginspection} className="bgimg" alt='service' />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 servicefont">
              <div className="d-flex gap-5 mobparapy">
                <p>Safety and Compliance are pivotal to your business. We fully understand this...</p>
                <Link to={`/Service/inspection`} className="text-decoration-none linkcolor">
                  <i className={`fa-solid fa-arrow-right service rounded-circle mobdisplay ${activeSection === "inspection" ? "rotate-arrow" : ""}`}></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-1 textalign">
              <Link to={`/Service/inspection`} className="text-decoration-none linkcolor">
                <i className={`fa-solid fa-arrow-right service rounded-circle webdisplay ${activeSection === "inspection" ? "rotate-arrow" : ""}`}></i>
              </Link>
            </div>

          </div>
          <div className={`collapse ${activeSection === "inspection" ? "show" : ""}`} id="tabs">
            <div className="container overflow-hidden padding-service ">
              <div className="row padding-service">
                <OwlCarousel
                  className="owl-theme"
                  loop={true}
                  margin={10}
                  nav={false}
                  // center={true}
                  dots={false}
                  autoplay={true}
                  autoplayTimeout={2000}
                  autoplayHoverPause={true}
                  responsive={{
                    0: { items: 1 },
                    600: { items: 2 },
                    1000: { items: 4 },
                  }}
                >
                  {cards1.map((cards, index) => (
                    <Link to={`/Service/inspection`} className="text-decoration-none linkcolor">
                      <div className="" key={index}>
                        <div
                          className={`card-item ${cards.colorClass} ${activeIndex === index ? "hover" : ""
                            }`}
                        // onMouseEnter={() => setActiveIndex(index)}
                        // onMouseLeave={() => setActiveIndex(0)}
                        >
                          <img src={hover} className={`hoverimg hoverimg${index}`} alt="hover" />
                          <div className="owlcard-container">
                            <img src={cards.image} className="owlcard" alt={`cards${index + 1}`} />
                          </div>
                          <h1>{cards.title}</h1>
                          <Link to={`/Service/inspection`} className="text-decoration-none linkcolor">
                            <i className="fa-solid fa-arrow-right cardarrow rounded-circle"></i>
                          </Link>
                        </div>
                      </div>
                    </Link>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
          <div className={`row padding-before border-b ${activeSection === "Trading" ? "padding-py" : ""}`}
            onMouseOver={() => toggleSection("Trading")}>
            <div className="col-lg-6">
              <div className="d-flex serviceicon gap-4">
                <div className="d-flex gap-4">
                  <p className="mobalign">
                    General Trading</p>
                  <div className={`collapse mt-3 ${activeSection === "Trading" ? "show positionbg" : ""}`} id="tabs">
                    <img src={bgtrading} className="bgimg" alt='service' />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 servicefont">
              <div className="d-flex gap-5 mobparapy" >
                <p>Our General Trading Division is dedicated to enhancing your Global Market Presence...</p>
                <Link to={`/Service/trading`} className="text-decoration-none linkcolor">
                  <i className={`fa-solid fa-arrow-right service rounded-circle mobdisplay ${activeSection === "Trading" ? "rotate-arrow" : ""}`}></i>
                </Link>
              </div>
            </div>
            <div className="col-lg-1 textalign">
              <Link to={`/Service/trading`} className="text-decoration-none linkcolor">
                <i className={`fa-solid fa-arrow-right service rounded-circle webdisplay ${activeSection === "Trading" ? "rotate-arrow" : ""}`}></i>
              </Link>
            </div>
          </div>

          <div className={`collapse ${activeSection === "Trading" ? "show" : ""}`} id="tabs">
            <div className="container padding-service overflow-hidden">
              <div className="row padding-service">
                <OwlCarousel
                  className="owl-theme"
                  loop={true}
                  margin={10}
                  nav={false}
                  // center={true}
                  dots={false}
                  autoplay={true}
                  autoplayTimeout={2000}
                  autoplayHoverPause={true}
                  responsive={{
                    0: { items: 1 },
                    600: { items: 2 },
                    1000: { items: 4 },
                  }}
                >
                  {cards2.map((cards2, index) => (
                    <Link to={`/Service/trading`} className="text-decoration-none linkcolor">
                      <div className="" key={index}>
                        <div
                          className={`card-item ${cards2.colorClass} ${activeIndex === index ? "hover" : ""
                            }`}
                        // onMouseEnter={() => setActiveIndex(index)}
                        // onMouseLeave={() => setActiveIndex(0)}
                        >
                          <img src={hover} className={`hoverimg hoverimg${index}`} alt="hover" />
                          <div className="owlcard-container">
                            <img src={cards2.image} className="owlcard" alt={`cards2${index + 1}`} />
                          </div>
                          <h1>{cards2.title}</h1>
                          {/* <p>
                        {card.content}
                      </p> */}
                          <Link to={`/Service/trading`} className="text-decoration-none linkcolor">
                            <i className="fa-solid fa-arrow-right cardarrow rounded-circle"></i>
                          </Link>
                        </div>
                      </div>
                    </Link>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="overflow-hidden about-section" id="Mission">
        <div className="container py-5">
          <div className="mission_banner " data-aos="fade-up" data-aos-duration="1000">
            <h1>
              Our Mission<span> & </span>Vision at Northwood
            </h1>
          </div>
          <div className="row gap-5 container justify-content-center py-5" >

            <div className="col-lg-5 col-12 missionupdate1" data-aos="flip-left" data-aos-duration="1000">
              <div className="borderbottom">
                <h4>Mission</h4>
              </div>
              <p className="mt-4">
                To deliver excellence in our services through efficient, sustainable, innovative and cost-effective solutions to our customers while developing long-term and meaningful associations.
              </p>
              <img src={mission1} className="missionimg" alt="" />
            </div>
            <div className="col-lg-5 col-12 missionupdate2" data-aos="flip-right" data-aos-duration="1000">
              <div className="borderbottom">
                <h4>Vision</h4>
              </div>
              <p className="mt-4">
                To become the most trusted and forward-thinking shipping partner through our exceptional services and partnerships.
              </p>
              <img src={mission2} className="missionimg" alt="" />
            </div>
          </div>
        </div>
      </section>


      <section className="overflow-hidden navscroll_1" id="AboutUs">
        <div className='container'>
          <div className='row aboutalign'>
            <div className='col-lg-4 about_banner '>
              <h1 className='mb-4' data-aos="fade-up" data-aos-duration="1000">
                About U<span className=''>s</span>
              </h1>
              <p className='mb-3 aboutpara' data-aos="fade-right" data-aos-duration="1000">
                Reliability is more than just a word, at Northwood.
              </p>
              <p className='mb-2' data-aos="fade-right" data-aos-duration="1000">
                From the moment your cargo is entrusted to us, we ensure its safe delivery with care and precision.
              </p>
            </div>
            <div className='col-lg-6' data-aos="fade-left" data-aos-duration="1000">
              <img src={group} className='group' alt='group' />

            </div>
          </div>
        </div>
        <div className="container mb-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="Aboutcontent">
                <p data-aos="zoom-in" data-aos-duration="1000"> In Freight forwarding, because we understand each shipment has its own story, deadlines to meet, quality to preserve and expectations to exceed, our seasoned team seamlessly simplifies the complexities of international shipping with pure expertise, experience and excellence.</p>
                <p data-aos="zoom-out" data-aos-duration="1000">
                  During Vessel Inspection, our highest priority is ensuring the highest standards of safety and efficiency are met.
                  In General Trading, Northwood stands for robustness.
                </p>
                <p data-aos="zoom-in" data-aos-duration="1000">
                  Our reputation has been built on trust and complete understanding of how the market works.In addition to commodities, we also trade solutions, providing strategic insights which will help companies thrive, even in volatile markets.
                </p>
                <p data-aos="zoom-out" data-aos-duration="1000">
                  In sourcing, negotiating or logistics, Northwood’s approach is much more hands-on, making sure every action counts.
                </p>
                <p data-aos="zoom-in" data-aos-duration="1000">
                  Aiming towards a reliable, robust and retention-based approach, Northwood aims to provide adaptive solutions.
                </p>
              </div>
            </div>

          </div>
        </div>
        <div className="rootcontent" data-aos="zoom-out" data-aos-duration="1000">
          Deep-rooted knowledge + Relentless Pursuit of Excellence is the<br />backbone of Northwood’s Operations.
        </div>
      </section>

      {/* <ourteam> */}
      <section className="overflow-hidden" id="Team">
        <div className="bg_team">
          <div className="container paddingteam ">
            <div className="teamhead" data-aos="fade-up" data-aos-duration="1000">
              <h1 >
                Team
              </h1>
            </div>
            <div className="Teamnew row justify-content-center">
              <div className="col-lg-8">
                <div className="teampypara" data-aos="zoom-in" data-aos-duration="1000">
                  We at Northwood, believe in our core values.
                </div>
                <p className="mt-3" data-aos="zoom-out" data-aos-duration="1000">
                  We are professionals in the industry with over three decades of extensive knowledge and experience in the day to day operations, port activities, freight forwarding, survey and inspections and other related activities of the<br /> shipping industry.<br /> We believe in focusing on consistently providing services of the highest quality while adapting to the individual needs of our clients.
                </p>
                {/* <p data-aos="zoom-in"  data-aos-duration="1000">
             
            </p> */}
                <div className="teampypara" data-aos="zoom-out" data-aos-duration="1000">
                  We aim at making a positive impact in the industry with our expertise, knowledge and dedicated team.
                </div>
              </div>
            </div>

          </div>

        </div>
        <div className="bg-teamdrop" data-aos="zoom-out" data-aos-duration="1000">
          Our biggest strength is that, despite our small size, we are growing, and we have a <br />100% dedication to serve our clients with undivided attention.
        </div>
      </section>



      {/* contact us section*/}

      <section className="overflow-hidden navscroll " id="Contactus">
        <div className="container py-5">
          <div className="contact_us">
            <p data-aos="zoom-in" data-aos-duration="1000">
              Contact Us
            </p>
            <h1 data-aos="fade-up" data-aos-duration="1000">
              Get In Touch With U<span>s</span>
            </h1>

          </div>

          <div className="getpy">
            <div>
              <NewFunction />

            </div>

          </div>

        </div>
      </section>


      {/* <section className="overflow-hidden">
        <div className="container py-5">
          <iframe title='googlemap' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3611.2940130734355!2d55.3006237743755!3d25.15954843322645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69c36f082541%3A0x16f65b407bb87f9!2sMeydan%20Grandstand!5e0!3m2!1sen!2sin!4v1739617243419!5m2!1sen!2sin" width="1150" height="450"  style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </section> */}
    </div>
  )
}

export default HomeContent
const NewFunction = () => {
  const [loading, setloading] = useState(false);
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setOpen(false);
  };

  const initialformstate =
  {
    Name: '', Country: '', Number: '', Company: '', Email: '', Designation: '', Message: '', Freight: false,
    Vessel: false,
    Trading: false,
    Others: false
  };
  const [isformdata, setformdata] = useState(initialformstate);
  // const handleformdata=(e)=>{
  //   const{name,value}=e.target 
  //   setformdata((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  // }
  const { name } = useParams();
  const handleformdata = (e) => {
    const { name, value, type, checked } = e.target;

    setformdata((prev) => {

      return { ...prev, [name]: type === "checkbox" ? checked : value };
    })
  };

  const [error, seterror] = useState({})
  const phoneValidation = (phone) => {
    const regex = /^([+]?[\s0-9]{1,16})?(\d{3}|[(]?[0-9]{1,16}[)])?([-]?[\s]?[0-9]{1,16})+$/;

    if (!phone || !regex.test(phone)) return false;

    const digitsOnly = phone.replace(/[+\s()-]/g, '');

    // Enforce length between 7 and 16 digits
    if (digitsOnly.length < 7 || digitsOnly.length > 16) return false;

    // Check for repeated digits (like 1111111)
    if (/^(\d)\1+$/.test(digitsOnly)) return false;

    return true;
  };

  const validate = () => {
    const newErrors = {};
    if (!isformdata.Name) newErrors.Name = 'Name cannot be empty';
    if (!isformdata.Country) newErrors.Country = 'Country cannot be empty';
    if (!isformdata.Company) newErrors.Company = 'Company cannot be empty';
    if (!isformdata.Email || !/\S+@\S+\.\S+/.test(isformdata.Email))
      newErrors.Email = 'Email cannot be empty';
    if (!isformdata.Number) {
      newErrors.Number = 'Number cannot be empty';
    } else if (!phoneValidation(isformdata.Number)) {
      newErrors.Number = 'Invalid phone number';
    }
    if (!isformdata.Designation) newErrors.Designation = 'Designation cannot be empty';
    // if (!isformdata.Message) newErrors.Message = 'Message is required.';
    return newErrors;
  };
  const handleSubmit = e => {
    e.preventDefault();
    setloading(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      seterror(validationErrors);
      setloading(false);
      return;
    }
    const formDataObj = new FormData();
    for (const key in isformdata) {
      formDataObj.append(key, isformdata[key]);
    }
    console.log('form submitted successfully', Array.from(formDataObj.entries()));
    seterror({});
    setformdata(initialformstate);
    console.log(formDataObj);
    axios.post('https://script.google.com/macros/s/AKfycbxokfNs-LU8ZaKjQ4R6CEupEfYB2_vjZthh8QFoq6cFeM1nGaTYEj5uMr_D49okuf_m/exec', formDataObj)
      // axios.post('https://script.google.com/macros/s/AKfycbw8okUfiPM13XZXDRU0ZapiPhBOXCzlu2KGN4ggSW6YpQz-Bct51CAHXA2Sqi2ndUYrTw/exec', formDataObj)
      .then(response => {
        console.log('Response:', response.data);
        setloading(false);
        setOpen(true);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row ">
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Your Name" name='Name'
              value={isformdata.Name}
              onChange={handleformdata}></input>
            {error.Name && <p className="mt-1 error">{error.Name}</p>}
          </div>
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Country" name='Country'
              value={isformdata.Country}
              onChange={handleformdata}></input>
            {error.Country && <p className="mt-1 error">{error.Country}</p>}
          </div>
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Contact Number" name='Number'
              value={isformdata.Number}
              onChange={handleformdata}></input>
            {error.Number && <p className="mt-1 error">{error.Number}</p>}
          </div>
        </div>
        <div className="row getpy getpy1">
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Email ID" name='Email'
              value={isformdata.Email}
              onChange={handleformdata}></input>
            {error.Email && <p className="mt-1 error">{error.Email}</p>}
          </div>
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Name of the Company" name='Company'
              value={isformdata.Company}
              onChange={handleformdata}></input>
            {error.Company && <p className="mt-1 error">{error.Company}</p>}
          </div>
          <div className="col-lg-4">
            <input class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Your Designation " name='Designation'
              value={isformdata.Designation}
              onChange={handleformdata}></input>
            {error.Designation && <p className="mt-1 error">{error.Designation}</p>}
          </div>
        </div>
        <div className="">
          <p className="field px-0">Required Services</p>
          <div className="row mt-3">
            {[
              { name: "Freight", label: "Freight Forwarding" },
              { name: "Vessel", label: "Vessel Inspection" },
              { name: "Trading", label: "General Trading" },
              { name: "Others", label: "Others" }
            ].map((service) => (
              <div className="col-lg-2" key={service.name}>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={service.name}
                    checked={isformdata[service.name]}
                    onChange={handleformdata} />
                  <label className="form-check-label checkfont">{service.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-lg-12 mt-5">
            {/* <label className="w-100 field fieldbox">Your Message</label>
        <input type='text' className="w-100 inputfield mt-5"
          name='Message'
          value={isformdata.Message}
          onChange={handleformdata} ></input> */}
            <textarea rows={3} class="form-control form-control-lg field inputfield px-0" type="text" placeholder="Your Message" name='Message'
              value={isformdata.Message}
              onChange={handleformdata}></textarea>
            {/* {error.Message && <p className="mt-1 error">{error.Message}</p>} */}
          </div>

        </div>
        <button className="d-flex flex-row gap-2 messagebtn" type="submit">
          {loading ? <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div> : "Get in Touch"}
          {!loading && <i class="fa-solid fa-arrow-right messagearrow mt-1"></i>}
        </button>

      </form>
      <CustomModal
        open={open}
        onClickOutside={() => {
          setOpen(false);
        }}
      >
        <div className="modal-content logout-modal p-5">
          <div className="m-auto">
            <img src={logo} className='modal-logo' alt='logo' />
          </div>

          <h5 className="text-center text-black modal-message py-3">
            Your Messgae Has Been Submitted Successfully!!!
          </h5>
          <button onClick={closeModal} className="contact mt-2">
            Close
          </button>
        </div>
      </CustomModal>
    </>
  );
}

